import { render, staticRenderFns } from "./contact-privacy.vue?vue&type=template&id=fc43742c&scoped=true&lang=pug&"
var script = {}
import style0 from "./contact-privacy.vue?vue&type=style&index=0&id=fc43742c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc43742c",
  null
  
)

export default component.exports